import api from "./apiHelper";

export const postCreatePolicy = (payload) => {
  return api.post(`/policy-library`, payload);
};

export const getPolicyLibraryList = () => {
  return api.get(`/policy-library`);
};

export const getPolicyLibraryDetails = (_id) => {
  return api.get(`/policy-library/${_id}`);
};

export const PatchPolicyLibrary = (_id, payload) => {
  return api.patch(`/policy-library/${_id}`, payload);
};

export const deletePolicyLibrary = (_id) => {
  return api.delete(`/policy-library/${_id}`);
};
export const revertPolicyLibrary = (body) => {
  return api.patch(`/policy-library/revert`, body);
};
